import { usePivonySonicSubscription } from "./usePivonySonicSubscription";
import { hasSonicProspectPlan } from "util/entitlements";

/**
 * Sonic Prospect front-door entitlement (org_subscriptions product_key).
 */
export function useSonicProspectAccess(authenticated, user) {
  const { subscriptionStatus, loading, hydrated } = usePivonySonicSubscription(
    authenticated,
    user
  );

  return {
    subscriptionStatus,
    hydrated,
    canAccess: hasSonicProspectPlan(subscriptionStatus),
    loading,
  };
}
